import { motion } from 'framer-motion';

export default function Projects() {
    return (
        <section id="projects" className="py-8 bg-background-light dark:bg-background-dark w-full">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    className="flex flex-col md:flex-row md:items-end justify-between mb-8"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <div>
                        <h2 className="text-3xl font-display font-bold text-gray-900 dark:text-white mb-2">Grants & Funded Projects</h2>
                        <p className="text-gray-600 dark:text-gray-400 max-w-2xl">
                            Leading research initiatives supported by national funding agencies to advance sustainable chemical engineering technologies.
                        </p>
                    </div>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">

                    {/* Ongoing Project 1 */}
                    <motion.div
                        className="bg-surface-light dark:bg-surface-dark rounded-xl shadow-md border-t-4 border-primary dark:border-blue-500 p-6 hover:shadow-xl transition-all duration-300 flex flex-col h-full"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <div className="flex justify-between items-start mb-4">
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300">
                                <span className="w-2 h-2 mr-2 bg-green-500 rounded-full animate-pulse"></span> Ongoing
                            </span>
                            <span className="text-lg font-bold text-primary dark:text-blue-400">₹111 Lakh</span>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">Hydrogen and Biodiesel Production using Organic Waste</h3>
                        <p className="text-gray-600 dark:text-gray-300 text-sm mb-6 flex-grow">
                            Investigating novel thermochemical pathways to convert mixed organic waste into clean hydrogen fuel and high-grade biodiesel, addressing both waste management and energy needs.
                        </p>
                        <div className="border-t border-gray-100 dark:border-gray-700 pt-4 mt-auto">
                            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                                <span className="material-icons text-base mr-2 text-gray-400">account_balance</span>
                                Department of Science & Technology (DST)
                            </div>
                        </div>
                    </motion.div>

                    {/* Ongoing Project 2 */}
                    <motion.div
                        className="bg-surface-light dark:bg-surface-dark rounded-xl shadow-md border-t-4 border-primary dark:border-blue-500 p-6 hover:shadow-xl transition-all duration-300 flex flex-col h-full"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <div className="flex justify-between items-start mb-4">
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300">
                                <span className="w-2 h-2 mr-2 bg-green-500 rounded-full animate-pulse"></span> Ongoing
                            </span>
                            <span className="text-lg font-bold text-primary dark:text-blue-400">₹20 Lakh</span>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">Development of Catalytic Membranes for Tannery Effluent Treatment</h3>
                        <p className="text-gray-600 dark:text-gray-300 text-sm mb-6 flex-grow">
                            Designing specialized catalytic membranes capable of degrading pollutants in tannery wastewater while simultaneously separating clean water for reuse.
                        </p>
                        <div className="border-t border-gray-100 dark:border-gray-700 pt-4 mt-auto">
                            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                                <span className="material-icons text-base mr-2 text-gray-400">account_balance</span>
                                CST-UP
                            </div>
                        </div>
                    </motion.div>

                    {/* Ongoing Project 3 */}
                    <motion.div
                        className="bg-surface-light dark:bg-surface-dark rounded-xl shadow-md border-t-4 border-primary dark:border-blue-500 p-6 hover:shadow-xl transition-all duration-300 flex flex-col h-full"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                    >
                        <div className="flex justify-between items-start mb-4">
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300">
                                <span className="w-2 h-2 mr-2 bg-green-500 rounded-full animate-pulse"></span> Ongoing
                            </span>
                            <span className="text-lg font-bold text-primary dark:text-blue-400">₹40 Lakh</span>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">Recovery and utilization of palladium from waste catalytic converters via solvent extraction and O/N functionalized g-C3N4 embedded membranes</h3>
                        <p className="text-gray-600 dark:text-gray-300 text-sm mb-6 flex-grow">
                            Developing sustainable methods for the recovery of precious palladium metals from spent catalytic converters using functionalized membranes and solvent extraction techniques.
                        </p>
                        <div className="border-t border-gray-100 dark:border-gray-700 pt-4 mt-auto">
                            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                                <span className="material-icons text-base mr-2 text-gray-400">account_balance</span>
                                Shiv Nadar Foundation
                            </div>
                        </div>
                    </motion.div>
                </div>

                <motion.div
                    className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-8 border border-gray-200 dark:border-gray-700"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.6 }}
                >
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-6 flex items-center">
                        <span className="material-icons mr-2 text-gray-500">task_alt</span> Completed Projects
                    </h3>

                    <div className="grid md:grid-cols-2 gap-6">
                        {/* Completed Project 1 */}
                        <div className="bg-white dark:bg-surface-dark p-5 rounded-lg border border-gray-200 dark:border-gray-700 flex flex-col">
                            <h4 className="font-bold text-gray-900 dark:text-white mb-2">Pyrolysis of Oil Extracted Spice Waste and Up-gradation of Bio-oil</h4>
                            <span className="text-lg font-bold text-primary dark:text-blue-400">₹10 Lakh</span>
                            <div className="mt-auto flex items-center justify-between text-sm pt-4">
                                <span className="text-gray-500 dark:text-gray-400">Funding Agency: CST-UP</span>
                                <span className="px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded text-xs font-medium text-gray-600 dark:text-gray-300">Completed</span>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </section>
    );
}